const state = {
    unit: {},
    units: [],
}
const actions = {
    showUnits: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/units`).then(response => {
                context.commit('SHOW_UNITS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showUnit: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/units/${id}`).then(response => {
                context.commit('SHOW_UNIT', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    storeUnit: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/units`, payload).then(response => {
                context.commit('STORE_UNIT', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateUnit: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/units/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    destroyUnit: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/units/${id}`).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    }
}
const mutations = {

    SHOW_UNIT: (state, payload) => {
        state.unit = payload
    },
    SHOW_UNITS: (state, payload) => {
        state.units = payload
    },
    STORE_UNIT: (state, payload) => {
        state.unit = payload
    }
}
const getters = {
    unit: state => {
        return state.unit
    },
    units: state => {
        return state.units
    }
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}